<div class="list-page-header">
  <div class="list-page-title">Card Transaction Activity</div>

  <div class="list-page-controls">
    <rkt-table-search (changed)="onSearch($event)" placeholder="Search by ID"></rkt-table-search>

    <div class="list-filters">
      <button type="button" class="table-header-filter-btn" (click)="filterMenu.toggle($event)" #filterBtn>
        <rkt-icon name="filter" class="table-header-filter-icon"></rkt-icon>
        Filter
        @if (activeFiltersCount) {
          <span class="table-header-filter-counter">{{ activeFiltersCount }}</span>
        }
      </button>
    </div>
  </div>
</div>

<div class="transaction-list card-transaction-list">
  <rkt-table
    [rows]="(transactions$ | async) || []"
    [columns]="columns"
    (fetchData)="getCardTransactions($event)"
    [count]="(totalElements$ | async)!"
    [loadingIndicator]="(loading$ | async)!"
    [offset]="activePage"
    [messages]="{ emptyMessage: 'No Card Transaction Activity found.' }"
    emptyValuePlaceholder="--"
    dateTimeFormat="MM/dd/yy HH:mm"
    [sortParam]="sortParams"
    [rowHeight]="64"
    (rowActivated)="onRowClick($event)"
  ></rkt-table>
</div>

<app-filter-menu
  #filterMenu
  [initialValues]="activeFilters"
  [filters]="filters"
  (opened)="filterBtn.classList.add('opened')"
  (closed)="filterBtn.classList.remove('opened')"
  (saved)="applyFilters($event)"
></app-filter-menu>
